<template>
    <div class="competition">
        <div class="competition-l">
            <div class="competition-name">
                <h3>{{comItem.name}}</h3>
            </div>
            <div class='tagBox'>
                <div class='tag'><span v-if='comItem.categoryName'>{{comItem.categoryName}}</span></div>
                <div class="competition-r">
                    <a v-if="comItem.holdStatus==1" href="javascript:;">进行中</a>
                    <a v-else-if="comItem.holdStatus==2" class="end-btn" href="javascript:;">已结束</a>
                    <a v-else href="javascript:;" class="begin-btn">未开始</a>
                </div>
            </div>
            <img v-if='comItem.picUrl' class="competition-info" :src="comItem.picUrl" />
            <div v-if='comItem.content' class="competition-info" v-html="comItem.content"></div>
            <div class="list-tips">
                <div class="article-tags-wrap" v-if="comItem.talkName">
                    <div class="article-tags">
                        <span class="tags-icon">#</span>
                        <span class="tags-name">{{comItem.talkName}}</span>
                    </div>
                </div>
            </div>
            <div class="competition-tips">
                <div class="competition-item">
                    <span class="organizer">浏览 {{comItem.viewNum}}</span>
                    <span class="organizer">参加人数 {{comItem.enrollNum}}</span>
                    <span class="organizer"> 时间：{{comItem.beginTime | datefmt('yyyy-MM-DD')}}～{{comItem.endTime | datefmt('yyyy-MM-DD')}} </span>
                    <span class="organizer">线下活动城市 {{comItem.acitvityAddress}}</span>
                </div>
                <div class="competition-r">
                    <div class="sign" v-if="comItem.holdStatus!=2 && comItem.enrollFlag == 0" @click.stop="toSign(comItem)">报名</div>
                    <div class="sign" v-if="comItem.holdStatus!=2 && comItem.enrollFlag == 1" @click.stop="toSign(comItem)">取消报名</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'

export default {
    name: 'detail',
    data() {
        return {
            id: '',
            comItem: {}
        }
    },
    created() {
        this.userId = localStorage.getItem('userId')
        this.id = this.$route.query.id
        this.getDetailById()
    },
    methods: {
        //根据id获取详情
        async getDetailById() {
            let param = {
                id: this.id,
                userId: this.userId
            }
            ajaxParam(param)
            const res = await post('v1/activity/getActivityInfo', qs.stringify(param))
            if (res.data.code == 200) {
                this.comItem = res.data.entity
            } else {
                this.$message.error(res.data.msg)
            }
        },
        toSign(item){
            this.$confirm('确定参加或者取消报名?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.submintSing(item)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
            });
        },
        async submintSing(item){
            let param = {
                userId: this.userId,
                activityId: item.id
            }
            ajaxParam(param)
            const res = await post('v1/activity/enrollActivity', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success('提交成功！')
                this.getDetailById()
            } else {
                this.$message.error(res.data.msg)
            }
        }
    }
}
</script>
<style scoped lang="less">
.competition {
    width: 1200px;
    min-height: 160px;
    margin: 50px auto 0;
    padding: 20px 0;
    background: #fff;
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .tagBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;

        .tag {
            display: inline-block;
            height: 28px;

            margin-right: 20px;
            padding: 0 10px;
            background: #F3F4F7;
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            cursor: pointer;
        }
    }


    .competition-l {
        flex: 1;
        min-height: 120px;
        padding: 0 40px;
        // border-right: 1px solid var(--color-border);

        .competition-name {
            display: flex;
            align-items: center;

            h3 {
                margin-right: 10px;
                font-size: 18px;
                font-weight: bold;
            }

            span {
                display: block;
                width: 62px;
                height: 18px;
                background: rgba(207, 23, 29, .18);
                border-radius: 4px;
                color: #DD0515;
                font-size: 10px;
            }
        }

        .competition-info {
            margin: 13px 0;
            font-size: 12px;
            color: var(--color-text-opacity);
            line-height: 22px;
        }

        .line2 {
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            -webkit-box-orient: vertical;
        }

        .competition-tips {
            display: flex;
            justify-content: space-between;
            .competition-item{
                display: flex;
                flex-direction: column;
            }

            .organizer {
                font-size: 12px;
                color: var(--color-text-opacity);
            }

            .bonus {
                font-size: 18px;
                font-weight: bold;
                color: #DD0515;
            }
        }
    }

    .competition-m {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 240px;
        height: 120px;
        border-right: 1px solid var(--color-border);

        ul {
            display: flex;
            margin-bottom: 8px;

            li {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 88px;
                height: 54px;
                margin-left: 2px;
                background: rgba(50, 50, 50, .06);
                border-radius: 2px;

                span:nth-of-type(1) {
                    padding-bottom: 2px;
                    font-weight: bold;
                }

                span:nth-of-type(2) {
                    font-size: 12px;
                }
            }
        }

        .deadline {
            font-size: 12px;
            color: var(--color-text-opacity);
        }
    }

    .competition-r {
        display: flex;
        flex-direction: column;
        width: 200px;
        align-items: center;

        a,.sign {
            width: 78px;
            height: 28px;
            background: #DD0515;
            border-radius: 4px;
            text-align: center;
            line-height: 28px;
            color: #fff;
            cursor: pointer;
        }

        .end-btn {
            background: #F3F4F7;
            color: var(--color-text-opacity);
        }

        .begin-btn {
            background: rgba(207, 23, 29, 0.1);
            border: 1px solid #DD0515;
            color: var(--color-text-a);
        }
    }

    .submit-btn {
        display: block;
        width: 88px;
        height: 34px;
        background: #DD0515;
        border-radius: 2px;
        margin-bottom: 12px;
        color: #fff;
        line-height: 34px;
        text-align: center;
    }

    .dialog-wrap .submit-btn {
        width: 200px;
        margin: 25px auto 0;
    }

    .list-tips {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0 10px;

        .article-tags-wrap {
            display: flex;
            cursor: pointer;
        }

        .article-tags {
            display: flex;
            border: 1px solid var(--color-border);
            margin-right: 15px;
            padding: 3px 5px;
            border-radius: 14px;

            .tags-icon {
                width: 18px;
                height: 18px;
                margin-right: 4px;
                background: #DD0515;
                border-radius: 14px;
                color: #fff;
                line-height: 18px;
                text-align: center;
            }

            .tags-name {
                font-size: 12px;
                color: var(--color-text);
            }
        }
    }

    .list-img {
        margin-top: 20px;

        img {
            height: 240px;
            max-width: 940px;
        }
    }

    /deep/ .el-dialog__body {
        padding-top: 10px;
    }
}
</style>